/**
 * @file Promise 相关的工具函数
 */
import { noop } from './lodash';
/**
 * 创建一个延迟执行的 promise 对象
 *
 * @category Promise
 * @returns promise 对象和 resolve / reject
 */
export const createDeferred = () => {
    let resolve = noop;
    let reject = noop;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return {
        promise,
        resolve,
        reject,
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvbWlzZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mdW5jdGlvbnMvcHJvbWlzZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUVILE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxVQUFVLENBQUE7QUFFL0I7Ozs7O0dBS0c7QUFDSCxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsR0FBTSxFQUFFO0lBQ3BDLElBQUksT0FBTyxHQUF3QyxJQUFJLENBQUE7SUFDdkQsSUFBSSxNQUFNLEdBQTJCLElBQUksQ0FBQTtJQUV6QyxNQUFNLE9BQU8sR0FBRyxJQUFJLE9BQU8sQ0FBSSxDQUFDLEdBQUcsRUFBRSxHQUFHLEVBQUUsRUFBRTtRQUMxQyxPQUFPLEdBQUcsR0FBRyxDQUFBO1FBQ2IsTUFBTSxHQUFHLEdBQUcsQ0FBQTtJQUNkLENBQUMsQ0FBQyxDQUFBO0lBRUYsT0FBTztRQUNMLE9BQU87UUFDUCxPQUFPO1FBQ1AsTUFBTTtLQUNQLENBQUE7QUFDSCxDQUFDLENBQUEifQ==